import React from 'react';

function Footer() {
    return (
        <footer>
            <p className="attribution">
               Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">Frontend Mentor</a>.
        Coded by <a href="https://www.linkedin.com/in/gift-amachree-8a523623b/">Gift Amachree</a> 
           </p> 
     </footer>
    );
}

export default Footer;